module.exports = __webpack_public_path__ + "img/reporting-colored.8b66f024.svg";